// extracted by mini-css-extract-plugin
export default {"bottomAd_box":"index_bottomAd_box_EutKj","bottomAd":"index_bottomAd_MrXmJ"};